import React from 'react'
import TravelInquiry from '@commons/bookings/travel-inquriy'

const BookingTravelInquiry = () => {
  return <TravelInquiry />
}

export default BookingTravelInquiry
